import * as React from 'react';
import { AddButton } from 'ui';
import { MdAdd } from 'react-icons/md';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { AccessPolicyTilesProps } from '../types';
import { AccessPolicyItem } from './access-policy-item';
import styles from './access-policy-tiles.scss';

export const AccessPolicyTiles = (props: AccessPolicyTilesProps) => {
  const { externalUrlGroupItem: { accessPolicy } = {}, translation, addAccessPolicy } = props;

  return <TileWrapper>
    <div className={styles.container}>
      {accessPolicy.map(item =>
        <AccessPolicyItem
          key={item.id}
          item={item}
          {...props} />)}
      <AddButton icon={MdAdd} onClick={addAccessPolicy}>
        {translation.add_access_policy}
      </AddButton>
    </div>
  </TileWrapper>;
};
